/**
 * HomePage — "/" route.
 * Landing v2 — Magnetic narrative structure:
 * 1. Movement (Hero)
 * 2. Direction (Experience paths)
 * 3. Reality (Life Signal — current activities)
 * 4. Hosts (Carousel — meet the hosts)
 * 5. Areas (Carousel — discover regions)
 * 6. Positioning (Brand stance)
 * 7. Calm action (Final CTA)
 */

import { Seo } from '@/components/common/Seo';
import LandingHeader from '@/components/landing/LandingHeader';
import LandingHeroV2 from '@/components/landing/LandingHeroV2';
import DirectionSection from '@/components/landing/DirectionSection';
import LifeSignalSection from '@/components/landing/LifeSignalSection';
import HostCarouselSection from '@/components/landing/HostCarouselSection';
import AreasCarouselSection from '@/components/landing/AreasCarouselSection';
import LandingAccommodationSection from '@/components/landing/LandingAccommodationSection';
import PositioningSection from '@/components/landing/PositioningSection';
import FinalCtaSection from '@/components/landing/FinalCtaSection';
import LandingProducerCta from '@/components/landing/LandingProducerCta';
import LandingMinimalFooter from '@/components/landing/LandingMinimalFooter';

const OG_IMAGE_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/og-home`;

export default function HomePage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Seo
        title="Farmly – Det som är äkta är värt att åka till"
        description="Kuraterade platser och upplevelser i Dalarna. Vi samlar det äkta – gårdar, natur och värdar värda att besöka."
        image={OG_IMAGE_URL}
        imageAlt="Farmly – det som är äkta är värt att åka till"
        ogType="website"
      />
      <LandingHeader variant="lens" />

      <main className="flex-1">
        <LandingHeroV2 />
        <DirectionSection />
        <LifeSignalSection />
        <HostCarouselSection />
        <AreasCarouselSection />
        <LandingAccommodationSection />
        <PositioningSection />
        <FinalCtaSection />
        <LandingProducerCta />
      </main>

      <LandingMinimalFooter />
    </div>
  );
}
